import { DiagnosticResults, ModemRebooting, Network } from '@app/views/Network';

import { NestedRoutes, RouteRenderProps } from '../utils';
import { NetworkLink } from '../constants';

export const networkRoutes: RouteRenderProps[] = [
  {
    path: NetworkLink.Network,
    render: <Network />,
    exact: true,
    fromParent: 0,
  },
  {
    path: NetworkLink.DiagnosticResults,
    render: <DiagnosticResults />,
    exact: true,
    fromParent: 0,
  },
  {
    path: NetworkLink.Reboot,
    render: <ModemRebooting />,
    exact: true,
    fromParent: 1,
  },
];

export const NetworkSwitch = (): JSX.Element => {
  return <NestedRoutes routes={networkRoutes} />;
};
